import React from 'react';

import Header from '../../components/user/header/Header.jsx';
import SubIntro from '../../components/user/sub_intro2/Intro.jsx';
import Content from '../../components/user/sub2_2/Content.jsx';

import Footer from '../../components/user/footer/Footer.jsx';

import s2_2_bg from '../../assets/images/s2_2_bg.png';

import '../../styles/user/common.css';
import '../../styles/user/default.css';
import '../../styles/user/fixed.css';
import '../../styles/user/font.css';
import '../../styles/user/footer.css';
import '../../styles/user/header.css';
import '../../styles/user/main.css';
import '../../styles/user/slick-theme.css';
import '../../styles/user/slick.css';
import '../../styles/user/sub.css';

export default function Sub2_2() {
  return (
    <>
      <Header />
      <SubIntro
        backgroundImage={s2_2_bg}
        mainTitle="최첨단 운송로봇"
        productName="creambot "
        productModel="S100"
        description="탁월한 100kg+ 배송 : 산업 이동성의 재정의"
        theme="dark"
        nogredient={true}
      />
      <Content />
      <Footer />
    </>
  );
}
